export default __webpack_public_path__ + "static/media/101.5285e644.jpg";